import { useCallback } from 'react'

let timer: any = null

type TUseTimer = {
  timer: null | ReturnType<typeof setTimeout>
  clearTimer: () => void
  setTimer: (fn: () => void, delay?: number) => void
}

/**
 * @description useTimer - set and clear a timer
 * @returns {TUseTimer} - the timer, clearTimer, and setTimer
 * @example
 *   const { timer, clearTimer, setTimer } = useTimer()
 *   setTimer(() => {
 *     console.log('Hello, world!')
 *   }, 1000)
 *   clearTimer()
 */
export const useTimer = (): TUseTimer => {
  const clearTimer = useCallback(() => {
    if (timer) clearTimeout(timer)
  }, [])

  const setTimer = useCallback((fn: () => void, delay: number = 0) => {
    timer = setTimeout(fn, delay)
  }, [])

  return {
    timer,
    clearTimer,
    setTimer,
  }
}
